import React, { useEffect, useState } from 'react';
import { db } from '../firebase/config';
import { collection, getDocs } from 'firebase/firestore';

interface Payment {
  id: string;
  userId: string;
  amount: number;
  createdAt: any;
}

interface User {
  id: string;
  displayName?: string;
  email?: string;
}

const AdminPaymentsDashboard: React.FC = () => {
  const [payments, setPayments] = useState<Payment[]>([]);
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const paymentsSnap = await getDocs(collection(db, 'payments'));
      const usersSnap = await getDocs(collection(db, 'users'));
      const paymentsList = paymentsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })) as Payment[];
      const usersList = usersSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })) as User[];
      setPayments(paymentsList);
      setUsers(usersList);
      setLoading(false);
    };
    fetchData();
  }, []);

  const getUserInfo = (userId: string) => {
    const user = users.find(u => u.id === userId);
    return user ? `${user.displayName || '-'} (${user.email || '-'})` : userId;
  };

  const total = payments.reduce((sum, p) => sum + (p.amount || 0), 0);

  return (
    <div className="admin-payments-dashboard">
      <h2>Pagamentos Recebidos</h2>
      <p>Total faturado: <strong>R$ {total.toLocaleString('pt-br', { minimumFractionDigits: 2 })}</strong></p>
      {loading ? <p>Carregando...</p> : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>Usuário</th>
              <th>Valor</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            {payments.map(p => (
              <tr key={p.id}>
                <td>{getUserInfo(p.userId)}</td>
                <td>R$ {p.amount?.toLocaleString('pt-br', { minimumFractionDigits: 2 })}</td>
                <td>{p.createdAt?.toDate ? p.createdAt.toDate().toLocaleDateString() : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminPaymentsDashboard;
